import { useRef, useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import audioData, { categoryDisplayNames } from "./audioData";
import "./Avatar.css";

const Avatar = () => {
  const [audio, setAudio] = useState();
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
  const [collapsedCategories, setCollapsedCategories] = useState({});
  let audioPlayerRef = useRef();

  function PlayAudio(newAudio, audioLabel) {
    if (newAudio === audio) {
      audioPlayerRef.current.pause();
      audioPlayerRef.current.currentTime = 0;
      audioPlayerRef.current.play();
    } else {
      setAudio(newAudio);
      setCurrentlyPlaying(audioLabel);
    }
  }

  // Handle audio ended event
  const handleAudioEnded = () => {
    setCurrentlyPlaying(null);
  };

  // Toggle category collapse
  const toggleCategory = (categoryKey) => {
    setCollapsedCategories((prev) => ({
      ...prev,
      [categoryKey]: !prev[categoryKey],
    }));
  };

  // Get DNC IVR audio data
  const dncIvr = audioData.find((a) => a.label === "DNC IVR");

  // Group audio data by category
  const groupedByCategory = Object.keys(categoryDisplayNames).reduce(
    (acc, category) => {
      acc[category] = audioData.filter((a) => a.category === category);
      return acc;
    },
    {}
  );

  // Render a category section
  const renderCategorySection = (categoryKey) => {
    const category = categoryDisplayNames[categoryKey];
    const isCollapsed = collapsedCategories[categoryKey];
    const style = {
      "--category-primary": category.colors.primary,
      "--category-gradient-start": category.colors.primary,
      "--category-gradient-end": category.colors.gradient,
      border: `2px solid ${category.colors.primary}`,
    };

    return (
      <div
        key={categoryKey}
        className={`category-section ${isCollapsed ? "collapsed" : ""}`}
        style={style}
      >
        <h3
          className="category-header"
          onClick={() => toggleCategory(categoryKey)}
        >
          <span>{category.label}</span>
          <button className="collapse-toggle">{isCollapsed ? "▼" : "▲"}</button>
        </h3>
        <div className="category-content">
          {groupedByCategory[categoryKey]?.map((a) => (
            <button
              key={a.label}
              className={`category-button ${
                currentlyPlaying === a.label ? "playing" : ""
              }`}
              onClick={() => PlayAudio(a.file, a.label)}
              title={a.description}
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="avatar-container">
      {/* DNC IVR and Audio Player */}
      <div className="audio-controls-bar">
        {dncIvr && (
          <button
            className={`dnc-button ${
              currentlyPlaying === dncIvr.label ? "playing" : ""
            }`}
            onClick={() => PlayAudio(dncIvr.file, dncIvr.label)}
            title={dncIvr.description}
          >
            {dncIvr.label}
          </button>
        )}
        <audio
          className="audio-player"
          controls
          controlsList="nodownload"
          autoPlay
          preload="auto"
          src={audio}
          ref={audioPlayerRef}
          onEnded={handleAudioEnded}
        >
          Your browser does not support the audio element.
        </audio>
      </div>

      {/* Masonry Grid Layout */}
      <div className="categories-grid">
        <ResponsiveMasonry
          columnsCountBreakPoints={{ 350: 1, 750: 2, 1200: 3, 1600: 4 }}
        >
          <Masonry gutter="8px" columnWidth="auto">
            {Object.keys(categoryDisplayNames).map(renderCategorySection)}
          </Masonry>
        </ResponsiveMasonry>
      </div>
    </div>
  );
};

export default Avatar;
